/*
* Broadcast Theme
*
* Use this file to add custom Javascript to Broadcast.  Keeping your custom
* Javascript in this fill will make it easier to update Broadcast. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*/


(function() {
  // Add custom code below this line

  /**
   * Checks if a specific product (proxy product) is present in the Shopify cart.
   * @param {string} productId - The ID of the product to check.
   * @returns {Promise<boolean>} - Resolves to `true` if the product is in the cart, otherwise `false`.
   */
  function checkProxyProductInCart(productId) {
    return fetch("/cart.js")
      .then((response) => response.json())
      .then((data) => {
        return data.items.some((item) => item.id === parseInt(productId, 10));
      })
      .catch((error) => {
        console.error("Error fetching cart:", error);
        return false; // Return false on error
      });
  }

  /**
  * Sets up event listeners to detect when the gift note accordion opens or closes.
  * Dispatches custom events `gift-note:added` and `gift-note:removed` accordingly.
  * @param {HTMLElement} checkboxElement - The accordion element to observe.
  */
  function addGiftNoteEventListeners(checkboxElement) {
    const giftNoteAdded = new Event("gift-note:added");
    const giftNoteRemoved = new Event("gift-note:removed");

    // Create a MutationObserver instance to watch attribute changes
    const observer = new MutationObserver((mutationsList) => {
      for (const mutation of mutationsList) {
        if (mutation.attributeName === "checked") {
          if (checkboxElement.checked) {
            document.dispatchEvent(giftNoteAdded);
          } else {
            document.dispatchEvent(giftNoteRemoved);
          }
        }
      }
    });

    const config = { attributes: true };
    observer.observe(checkboxElement, config);
  }

  /**
  * Initializes the gift note accordion to open
  * if the proxy product is in the cart.
  * @param {HTMLElement} widgetElement - The accordion element to toggle.
  */
  function initGiftNoteAccordion(widgetElement) {
    const proxyProductId = "51828972585332";
    const trigger = widgetElement.querySelector('[data-collapsible-trigger]');

    checkProxyProductInCart(proxyProductId).then((isInCart) => {
      if (!isInCart) return; // Do nothing if the product is not in the cart
      trigger.click();
    });
  }

  /**
   * Initializes the gift note checkbox to be checked
   * if the proxy product is in the cart.
   * @param {HTMLElement} checkboxElement - The checkbox element to toggle.
   */
  function initGiftNoteCheckbox(checkboxElement) {
    const proxyProductId = "51828972585332";

    checkProxyProductInCart(proxyProductId).then((isInCart) => {
      if (!isInCart) return; // Do nothing if the product is not in the cart
      checkboxElement.checked = true;
      checkboxElement.dispatchEvent(new Event("change")); // Trigger change event if needed
    });
  }

  /**
  * Toggles the gift note accordion.
  * @param {HTMLElement} widgetElement - The accordion element to toggle.
  */
  function toggleGiftNoteAccordion(isGiftAdded = false) {
    const giftNoteElement = document.getElementById("gift-note");
    if (!giftNoteElement) return; // Avoid errors if element is missing

    const giftNoteWidget = giftNoteElement.closest(".cart__widget.accordion");
    const trigger = giftNoteWidget.querySelector('[data-collapsible-trigger]');
    giftNoteElement.value = '';
    if (giftNoteWidget.getAttribute("open") === "true" && isGiftAdded) {
      return;
    }
    if (giftNoteWidget.getAttribute("open") === "true" || isGiftAdded) {
      trigger.click();
    }
  }

  /**
   * Makes the gift note textarea read-only until gift wrapping is turned on.
   *
   * a11y: this used to set `disabled`, which removes the field from the tab order
   * entirely — so a keyboard or screen reader user never landed on it and never read
   * the one sentence explaining why they could not type. `readonly` keeps the field
   * focusable and announced, and the instruction now lives in a real hint element
   * wired up with aria-describedby rather than in a placeholder.
   *
   * @param {HTMLElement} checkboxElement - The checkbox element to watch.
   * @param {HTMLElement} textareaElement - The textarea element to toggle.
   */
  function toggleGiftNoteTextarea(checkboxElement, textareaElement) {
    const hintElement = document.querySelector("[data-gift-note-hint]");

    function updateTextareaState() {
      const enabled = checkboxElement.checked;

      textareaElement.readOnly = !enabled;
      textareaElement.setAttribute("aria-readonly", String(!enabled));

      if (!enabled) {
        textareaElement.value = ""; // Clear text when gift wrapping is off
      }

      if (hintElement) {
        hintElement.hidden = enabled;
      }
    }

    // Initial state check
    updateTextareaState();

    // Listen for changes on the checkbox
    checkboxElement.addEventListener("change", updateTextareaState);
  }
  /**
  * Initializes gift note functionality when the page loads.
  * Attaches event listeners and toggles the accordion if needed.
  */
  document.addEventListener("DOMContentLoaded", () => {
    const giftNoteCheckbox = document.getElementById("gift-wrap-checkbox");
    const giftNoteElement = document.getElementById("gift-note");

    let timeoutId;
    const delay = 1000;

    // Guard first: these elements only exist on cart surfaces. Without this, the
    // unguarded addEventListener below threw on every other page and aborted the
    // rest of this handler — taking the checkbox wiring down with it.
    if (!giftNoteCheckbox || !giftNoteElement) return;

    giftNoteElement.addEventListener('input', () => {
      clearTimeout(timeoutId);
      timeoutId = setTimeout(() => {
        fetch(window.Shopify.routes.root + 'cart/update.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json'
          },
          body: JSON.stringify({ note: giftNoteElement.value })
        });
      }, delay);
    });

    toggleGiftNoteTextarea(giftNoteCheckbox, giftNoteElement);

    giftNoteCheckbox.addEventListener("change", () => {
      giftNoteCheckbox.setAttribute("checked", giftNoteCheckbox.checked);
    });

    const giftNoteWidget = giftNoteCheckbox.closest(".cart__widget.accordion");

    if (giftNoteWidget) {
      addGiftNoteEventListeners(giftNoteCheckbox);
      initGiftNoteCheckbox(giftNoteCheckbox);
      initGiftNoteAccordion(giftNoteWidget);
    }
  });

  /**
  * Event listener for when a gift note is added.
  * Checks if the proxy product is already in the cart before adding it.
  */
  document.addEventListener("gift-note:added", () => {
    const proxyProductId = "51828972585332";
    checkProxyProductInCart(proxyProductId).then((isInCart) => {
      if (isInCart) return; // Do not add duplicate items

      fetch("/cart/add.js", {
        method: "POST",
        headers: {
          "Content-Type": "application/json"
        },
        body: JSON.stringify({
          id: proxyProductId,
          quantity: 1
        })
      })
        .then((response) => response.json())
        .then((data) => {
          console.log("Product added to cart:", data);
        })
        .then(() => {
          document.dispatchEvent(new Event("theme:cart:refresh", { bubbles: true }));
        })
        .catch((error) => console.error("Error adding product:", error))
        .finally(() => {
          toggleGiftNoteAccordion(true);
        });
    });
  });

  /**
  * Event listener for when a gift note is removed.
  * Removes the associated proxy product from the cart and closes the accordion if open.
  */
  document.addEventListener("gift-note:removed", () => {
    const giftNoteItem = document.querySelector('[data-item^="51828972585332:"]');
    if (!giftNoteItem) return; // Avoid errors if the item is not found
    
    const removeButton = giftNoteItem.querySelector('[data-item-remove]');
    removeButton.click();

    toggleGiftNoteAccordion();
  });

  document.addEventListener("theme:cart:change", () => {
    const proxyProductId = "51828972585332";

    checkProxyProductInCart(proxyProductId).then((isInCart) => {
      if (isInCart) return; // Do nothing if the product is in the cart
      toggleGiftNoteAccordion();
    });
  });

  // ^^ Keep your scripts inside this IIFE function call to 
  // avoid leaking your variables into the global scope.
})();
